import {
  Locale,
  useEffect,
  useLocation,
  useState,
  toast,
} from '../../../libraries/index';
import { Finance } from '../../pages/index';
import {
  isNotRequiredName,
  isRequired,
  isRequiredSelect,
  isValidEmail1,
  isValidPhoneNumber,
} from '../../pages/Validation/Validation';
import {
  handleErrorResponse,
  handleSuccessResponse,
  createBillingInformation,
  fetchBillingInformation,
  updateBillingInformation,
} from '../../../services/index';
import { AddressJson, CountryCodeJson } from '../../../jsonData';
import { fetchCitiesDropdown, fetchCountries, fetchStateDropdown, fetchStates } from '../../../common/addressSelect/util';
import { isNotRequiredValidPostalCode, isSelect, isValidPostalCode } from '../../../common/validation/fieldRegex';
import { CancelDeletionAction } from '../../../lazyComponent';
import { getCountryCodeBasedOnCountry } from '../../../util';

const Finances = ({ deletionRequest, setDeletionRequest }) => {
  const { t } = Locale();
  const location = useLocation();
  const initialValues = {
    title: '',
    taxId: '',
    billingAddress: '',
    company_country: '',
    bank_country: '',
    contactName: '',
    email: '',
    phoneCountryCode: '',
    phone: '',
    billingContactPhoneCountryCode: '',
    billingContactPhone: '',
    accountHolderName: '',
    accountNumber: '',
    bankBranchCode: '',
    iban: '',
    bankName: '',
    bankAddress: '',
    postal_code: '',
    bank_postal_code: '',
    cheque: '',
    chequeName: '',
    state: '',
    city: '',
    bankState: '',
    bankCity: '',
    gstNumber: '',
    micrCode: '',
    ifscCode: ''
  };

  const previousValue = {
    title: '',
    taxId: '',
    billingAddress: '',
    contactName: '',
    email: '',
    phoneCountryCode: '',
    phone: '',
    billingContactPhoneCountryCode: '',
    billingContactPhone: '',
    accountHolderName: '',
    accountNumber: '',
    bankBranchCode: '',
    iban: '',
    bankName: '',
    bankAddress: '',
    postal_code: '',
    bank_postal_code: '',
    cheque: '',
    chequeName: '',
    company_country: '',
    bank_country: '',
    gstNumber: '',
    micrCode: '',
    ifscCode: ''
  };

  const addressInitialValues = {
    country: { id: '', name: '' },
    companyState: { id: '', name: '', code: '' },
    companyCity: { name: '' },
    companyPostalCode: { value: '' },
    bankState: { id: '', name: '', code: '' },
    bankCity: { name: '' },
    bankPostalCode: { value: '' }
  }

  const previousAddressInitialValues = {
    country: { id: '', name: '' },
    companyState: { id: '', name: '', code: '' },
    companyCity: { name: '' },
    companyPostalCode: { value: '' },
    bankState: { id: '', name: '', code: '' },
    bankCity: { name: '' },
    bankPostalCode: { value: '' }
  }

  const [addressFormValue, setAddressFormValue] = useState(addressInitialValues);
  const [addressPreviousFormValue, setAddressPreviousFormValue] = useState(previousAddressInitialValues);
  const [previousFormValue, setPreviousFormValue] = useState(previousValue)
  const [billingInformationResponse, setBillingInformationResponse] = useState(null);
  const [formValue, setFormValue] = useState(initialValues);
  const [formError, setFormError] = useState({});
  const [uploadedCheque, setUploadedCheque] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [isLoader, setIsLoader] = useState(true);

  const isSection = localStorage.getItem('isSection');
  const isFreelancer = localStorage.getItem('type') === 'true'
  const registeredCountry = sessionStorage.getItem('country')
  const deletionRequestStatus = localStorage.getItem('deletionRequestStatus') === 'requested'



  useEffect(() => {
    if (isSection !== 'isBusinessFinance') {
      localStorage.setItem('isSection', 'isBusinessFinance');
    }
  }, [location.pathname]);

  useEffect(() => {
    billingInformation();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (
        billingInformationResponse &&
        billingInformationResponse?.billing_information
      ) {
        let phone_number =
          billingInformationResponse?.billing_information &&
          billingInformationResponse?.billing_information &&
          billingInformationResponse?.billing_information?.phone_number &&
          billingInformationResponse?.billing_information?.phone_number.split(' ')
            .length > 1 &&
          billingInformationResponse.billing_information.phone_number

            .split(' ')[1]
            .toString();

        let c_phone_number =
          billingInformationResponse.billing_information &&
          billingInformationResponse.billing_information.contact_number &&
          billingInformationResponse.billing_information.contact_number &&
          billingInformationResponse.billing_information.contact_number.split(' ')
            .length > 1 &&
          billingInformationResponse.billing_information.contact_number
            .split(' ')[1]
            .toString();

        let tempCountryCode =
          billingInformationResponse.billing_information &&
          billingInformationResponse.billing_information &&
          billingInformationResponse.billing_information.phone_number &&
          billingInformationResponse.billing_information.phone_number.split(' ')
            .length > 1 &&
          billingInformationResponse.billing_information.phone_number
            .split(' ')[0]
            .toString();
        let tempConCountryCode =
          billingInformationResponse.billing_information &&
          billingInformationResponse.billing_information &&
          billingInformationResponse.billing_information.contact_number &&
          billingInformationResponse.billing_information.contact_number.split(' ')
            .length > 1 &&
          billingInformationResponse.billing_information.contact_number
            .split(' ')[0]
            .toString();

        const updateValue = {
          accountHolderName:
            billingInformationResponse.billing_information.account_holder_name,
          title: billingInformationResponse.billing_information.company_name,
          taxId: billingInformationResponse.billing_information.vat_number,
          gstNumber: billingInformationResponse?.billing_information?.gst_number || '',
          micrCode: billingInformationResponse?.billing_information?.micr_code || '',
          ifscCode: billingInformationResponse?.billing_information?.ifsc_code || '',
          billingAddress:
            billingInformationResponse.billing_information.billing_address,
          company_country: billingInformationResponse.billing_information.country,
          contactName:
            billingInformationResponse.billing_information.contact_name,
          email: billingInformationResponse.billing_information.email,
          phone: phone_number,
          billingContactPhone: c_phone_number,
          accountNumber:
            billingInformationResponse.billing_information.account_number,
          bankBranchCode:
            billingInformationResponse.billing_information.bank_branch_code,
          iban: billingInformationResponse.billing_information.iban,
          bankName: billingInformationResponse.billing_information.bank_name,
          bankAddress:
            billingInformationResponse.billing_information.bank_address,
          bank_country:
            billingInformationResponse.billing_information.bank_country,
          postal_code: billingInformationResponse.billing_information.postal_code,
          bank_postal_code:
            billingInformationResponse.billing_information.bank_postal_code,
          phoneCountryCode: tempCountryCode ? tempCountryCode : '+66',
          billingContactPhoneCountryCode: tempConCountryCode ? tempConCountryCode : '+66',

          cheque:
            billingInformationResponse.image_url &&
            billingInformationResponse.image_url,
          chequeName: billingInformationResponse?.file_name,
        }
        const countryCode = await getCountryCodeBasedOnCountry(registeredCountry);
        const updateAddressValue = {
          country: { name: registeredCountry, code: countryCode },
          companyState: billingInformationResponse.billing_information.state,
          companyCity: billingInformationResponse.billing_information.city,
          companyPostalCode: billingInformationResponse.billing_information.postal_code,
          bankState: billingInformationResponse.billing_information.bank_state,
          bankCity: billingInformationResponse.billing_information.bank_city,
          bankPostalCode: billingInformationResponse.billing_information.bank_postal_code,
        }
        setFormValue(updateValue);
        setPreviousFormValue(updateValue)
        setAddressFormValue(updateAddressValue)
        setAddressPreviousFormValue(updateAddressValue)
      }
    }
    fetchData();
  }, [billingInformationResponse]);


  const billingInformation = async () => {
    try {
      let response = await fetchBillingInformation();
      setBillingInformationResponse(response?.data);
      if (response?.data?.status === 200 || response?.data?.status === 201)
        setIsUpdate(true);
      setIsLoader(false);
      handleSuccessResponse(response);
    } catch (err) {
      setIsLoader(false);
      if (err?.response?.data?.status_code === 404) {
        handleErrorResponse(err);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const error = getValidationHandleChange(name, value);
    setFormError(error)
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (!file.type.includes('pdf')) {
        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
          const errorMessage = `${t('validation.imageSize')}`;
          setFormError((prevErrors) => ({
            ...prevErrors,
            cheque: errorMessage,
          }));
          setUploadedCheque(null);
          setFormValue((prev) => ({
            ...prev,
            cheque: null,
          }));

          return;
        }
      }

      setFormValue((prevValues) => ({
        ...prevValues,
        cheque: file,
      }));
      setUploadedCheque(URL.createObjectURL(file));
    } else {
      setFormValue({ ...formValue, [name]: value });
    }
  };


  const handleCountryCode = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      phoneCountryCode: e.dialCode,
    }));

  }

  const handlePhoneNumberChange = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      phone: e.nationalNumber,
      phoneCountryCode: e.dialCode,
    }));
    const errorLogs = getValidationHandleChange('phone', e.nationalNumber);
    setFormError(errorLogs);
  }

  const handleContactCountryCode = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      billingContactPhoneCountryCode: e.dialCode,
    }));

  }

  const handleContactPhoneNumberChange = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      billingContactPhone: e.nationalNumber,
      billingContactPhoneCountryCode: e.dialCode,
    }));
    const errorLogs = getValidationHandleChange('billingContactPhone', e.nationalNumber);
    setFormError(errorLogs);
  }


  const getValidationHandleChange = (name, value, uploadedCheque) => {
    let error = { ...formError };
    if (error.hasOwnProperty(name)) {
      delete error[name];
    }

    switch (name) {
      case 'billingContactPhone':
        error = isValidPhoneNumber(
          value,
          error,
          'billingContactPhone',
          `${t('financeField.billContactPhoneNumber')}`,
          '',
          t
        );
        break;
      case 'phone':
        error = isValidPhoneNumber(
          value,
          error,
          'phone',
          `${t('field.phoneNumber')}`,
          '',
          t
        );
        break;
      case 'title':
        error = isRequired(
          value,
          error,
          'title',
          `${!isFreelancer ? t("financeField.companyName") : t("financeField.freelancerName")}`,
          t
        );
        break;
      case 'billingAddress':
        error = isRequired(
          value,
          error,
          'billingAddress',
          `${t('financeField.billingAddress')}`,
          t
        );
        break;

      case 'company_country':
        error = isRequiredSelect(
          value,
          error,
          'company_country',
          `${t('financeField.country')}`,
          t
        );
        break;
      case 'contactName':
        error = isRequired(
          value,
          error,
          'contactName',
          `${t('financeField.contactName')}`,
          t
        );
        break;
      case 'email':
        error = isValidEmail1(value, error, 'email', t);
        break;

      case 'companyState':
        error = isSelect(value, { ...error }, 'companyState', `${t("field.state")}`, t)
        break;
      case 'companyCity':
        error = isSelect((value), { ...error }, 'companyCity', `${t("field.city")}`, t)
        break;
      case 'companyPostalCode':
        error = isValidPostalCode(value, { ...error }, 'companyPostalCode', `${t("field.postalCode")}`, t, addressFormValue?.country?.name)
        break;
      case 'accountHolderName':
        error = isNotRequiredName(
          value,
          error,
          'accountHolderName',
          `${t('financeField.accountHolderName')}`,
          t
        );
        break;
      case 'bankPostalCode':
        error = isNotRequiredValidPostalCode(value, { ...error }, 'bankPostalCode', `${t("field.postalCode")}`, t, addressFormValue?.country?.name)
        break;

      default:
        break;
    }
    return error;
  };


  const handleCountryChange = (name, value) => {
    const err = getValidationHandleChange(name, value);
    setFormError(err);
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const checkIfUpdated = () => {
    return (JSON.stringify(formValue) !== JSON.stringify(previousFormValue)) || (JSON.stringify(addressFormValue) !== JSON.stringify(addressPreviousFormValue));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    errors = validate(formValue, uploadedCheque);
    setFormError(errors);
    if (Object.keys(errors).length === 0) {
      setButtonDisabled(true);
      const formData = await appendData(formValue);
      try {
        let response;
        if (!isUpdate) {
          try {
            response = await createBillingInformation(formData);
            handleSuccessResponse(response, response.data.message);
            setIsUpdate(true);
            setButtonDisabled(false);
          } catch (err) {
            handleErrorResponse(err);
            setButtonDisabled(false);

          }
        } else {
          setButtonDisabled(true);
          if (checkIfUpdated()) {
            response = await updateBillingInformation(formData);
            handleSuccessResponse(response, response.data.message);
          }
          else {
            toast.error(t('userEdit.noUpdateMessage'));
          }
          setButtonDisabled(false);
        }
      } catch (err) {
        handleErrorResponse(err);
        setButtonDisabled(false);
      }
    }
  };

  const validate = (formValue, uploadedCheque) => {
    let error;
    error = isValidPhoneNumber(
      formValue.billingContactPhone,
      { ...error },
      'billingContactPhone',
      `${t('financeField.billContactPhoneNumber')}`,
      '',
      t,
    );

    error = isValidPhoneNumber(
      formValue.phone,
      error,
      'phone',
      `${t('field.phoneNumber')}`,
      '',
      t
    );

    error = isRequired(
      formValue.title,
      { ...error },
      'title',
      `${!isFreelancer ? t("financeField.companyName") : t("financeField.freelancerName")}`,
      t,
    );

    error = isRequired(
      formValue.billingAddress,
      { ...error },
      'billingAddress',
      `${t('financeField.billingAddress')}`,
      t,
    );
    error = isRequired(
      formValue.contactName,
      { ...error },
      'contactName',
      `${t('financeField.contactName')}`,
      t,
    );
    error = isValidEmail1(formValue.email, { ...error }, 'email', t);
    error = isNotRequiredName(
      formValue.accountHolderName,
      { ...error },
      'accountHolderName',
      `${t('financeField.accountHolderName')}`,
      t,
    );

    if (addressFormValue?.country?.name !== 'Thailand') {
      error = isSelect((addressFormValue?.companyState?.name), { ...error }, 'companyState', `${t("field.state")}`, t)
      error = isSelect((addressFormValue?.companyCity?.name), { ...error }, 'companyCity', `${t("field.city")}`, t)
    }
    else {
      error = isSelect((formValue?.company_country), { ...error }, 'company_country', `${t("field.country")}`, t)
    }
    error = isValidPostalCode((addressFormValue?.companyPostalCode?.value), { ...error }, 'companyPostalCode', `${t("field.postalCode")}`, t, addressFormValue?.country?.name)
    return error;
  };

  const appendData = (formValue) => {
    const formData = new FormData();
    formData.append('company_name', formValue.title);

    formData.append('postal_code', addressFormValue?.companyPostalCode);
    formData.append('billing_address', formValue.billingAddress);
    formData.append('contact_name', formValue.contactName);
    formData.append('email', formValue.email);
    let removeCountryNamePhoneCountryCode = formValue.phoneCountryCode
      ? formValue.phoneCountryCode.split('(')[0].trim()
      : '+66';

    formData.append(
      'phone_number',
      removeCountryNamePhoneCountryCode + ' ' + formValue.phone,
    );

    let removeCountryNameConCountryCode = formValue.billingContactPhoneCountryCode
      ? formValue.billingContactPhoneCountryCode.split('(')[0].trim()
      : '+66';

    formData.append(
      'contact_number',
      removeCountryNameConCountryCode + ' ' + formValue.billingContactPhone,
    );

    formData.append('account_holder_name', formValue.accountHolderName);
    formData.append('account_number', formValue.accountNumber);
    formData.append('bank_name', formValue.bankName);

    formData.append('bank_address', formValue.bankAddress);
    formData.append('bank_country', addressFormValue?.country?.name === 'Thailand' ? formValue.bank_country : addressFormValue?.country?.name);
    formData.append('country', addressFormValue?.country?.name === 'Thailand' ? formValue.company_country : addressFormValue?.country?.name);
    formData.append('bank_postal_code', addressFormValue?.bankPostalCode);
    if (addressFormValue?.country?.name !== 'Thailand') {
      formData.append('gst_number', formValue?.gstNumber);
      formData.append('micr_code', formValue?.micrCode);
      formData.append('ifsc_code', formValue?.ifscCode);
      formData.append('state', addressFormValue?.companyState);
      formData.append('city', addressFormValue?.companyCity);
      formData.append('bank_state', addressFormValue?.bankState);
      formData.append('bank_city', addressFormValue?.bankCity);
    }
    else {
      formData.append('vat_number', formValue.taxId);
      formData.append('bank_branch_code', formValue.bankBranchCode);
      formData.append('iban', formValue.iban);
    }
    if (typeof formValue.cheque !== 'string') {
      formData.append('cheque', formValue.cheque);
    }
    return formData;
  };


  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


  const handleStateChange = (value, section) => {
    const selectedOption = stateDropdown.find((option) => option.value === value);
    if (section === 'companyDetails') {
      let tempEror = getValidationHandleChange('companyState', value)
      setFormError(tempEror)
      setAddressFormValue((prev) => ({
        ...prev,
        companyState: { id: selectedOption.id, name: selectedOption.name, code: selectedOption?.state_code },
        companyCity: { name: undefined },
        companyPostalCode: { value: '' },
      }));
      fetchCompanyCityDropdownData(addressFormValue?.country?.id, selectedOption.id)
    }

    else {
      let tempEror = getValidationHandleChange('bankState', value)
      setFormError(tempEror)
      setAddressFormValue((prev) => ({
        ...prev,
        bankState: { id: selectedOption.id, name: selectedOption.name, code: selectedOption?.state_code },
        bankCity: { name: '' },
        bankPostalCode: { value: '' }
      }));
      fetchBankCityDropdownData(addressFormValue?.country?.id, selectedOption.id)
    }
  };

  const handlePostalCodeChange = async (name, value) => {
    setAddressFormValue((prev) => ({
      ...prev,
      [name]: value,
    }))
  };

  const handleCityTypeChange = (e) => {
    const { name, value } = e.target;
    setAddressFormValue((prev) => ({
      ...prev,
      [name]: { name: value }
    }))
    let tempEror = getValidationHandleChange(name, value)
    setFormError(tempEror)
  }

  const handlePostalCode = (e, section) => {
    if (section === 'companyDetails') {
      let tempEror = getValidationHandleChange('companyPostalCode', e);
      setFormError(tempEror)
      setAddressFormValue((prev) => ({
        ...prev,
        companyPostalCode: { value: e }
      }));
    }
    else {
      let tempEror = getValidationHandleChange('bankPostalCode', e);
      setFormError(tempEror)
      setAddressFormValue((prev) => ({
        ...prev,
        bankPostalCode: { value: e }
      }));
    }
  }


  return (
    <>
      {deletionRequestStatus ? (
        <>
          <CancelDeletionAction
            setDeletionRequest={setDeletionRequest}
            deletionRequest={deletionRequest}
          />
        </>
      ) : (
        <Finance
          handleCountryCode={handleCountryCode}
          handlePhoneNumberChange={handlePhoneNumberChange}
          handleContactCountryCode={handleContactCountryCode}
          handleContactPhoneNumberChange={handleContactPhoneNumberChange}
          handleCityTypeChange={handleCityTypeChange}
          isLoader={isLoader}
          isUpdate={isUpdate}
          uploadedCheque={uploadedCheque}
          formValue={formValue}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          formError={formError}
          buttonDisabled={buttonDisabled}
          handleStateChange={handleStateChange}
          handleCityChange={handleCityChange}
          handlePostalCode={handlePostalCode}
          addressFormValue={addressFormValue}
          filterOption={filterOption}
          deletionRequest={deletionRequest}
          handleCountryChange={handleCountryChange}
        />
      )}
    </>
  );
};
export default Finances;